export const spacedOutTextStyle = {
  lineHeight: "1.6",
  letterSpacing: "1px",
};
